export const JIRA_ISSUE_TYPE_VARIANTS: Record<string, string[]> = {
  Bug: ['bug', 'defect', 'error', 'bogue', 'fehler', 'defecto'],
  Task: ['task', 'tarea', 'tâche', 'aufgabe', 'tarefa'],
  Story: ['story', 'historia', 'estória', 'história', 'geschichte'],
};
